import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTitle } from '../../Application';

import OnboardingView from '../../ui/components/Onboarding/Onboarding';

import { authenticate } from '../../Authentication/actions';
import { createDevice, fetchDevices } from '../../connectors/Devices/actions';

import ToasterService from "../../utils/ToasterService"
import {deleteUser} from "../../connectors/Users/actions";
import log from 'loglevel'

import toast from '../../utils/ToasterService';
import { pingURL, sendRequest } from '../../services/api/apiClient';
import {t} from 'i18next'

const title = 'Anmelden';

const mapStateToProps = state => ({
    title: state.application.title,
    authenticated: state.authentication.authenticated,
    allDevices: state.devices.map
});

const mapDispatchToProps = dispatch => ({
    authenticate: (username, password) => dispatch(authenticate(username, password)),
    fetchDevices: (callback) => dispatch(fetchDevices(callback)),
    createDevice: (device, callback, errorCBN) => dispatch(createDevice(device, callback, errorCBN)),
    deleteUser: (successCb, errorCb) => dispatch(deleteUser(successCb, errorCb)),
});

/**
 * Login
 */
class Onboarding extends PureComponent {
    static propTypes = {
        authenticate: PropTypes.func.isRequired,
        authenticated: PropTypes.bool,
    }

    static defaultProps = {
        authenticated: false,
    }

    checkConnectionToServer=()=>{
        sendRequest('get', pingURL)
        .then(() => {
          //console.log('Response Ok: Server working!');
        })
        .catch(error => {
          //console.error('Cannot Connect to Server:', error);
          //Server Failure Toast here
          toast.error(t('Global.toast_server_disconnect'));
        });
      }

    handleLogin = (username, password) => {
        this.checkConnectionToServer()
        this.props.authenticate(username, password);
    }

    handleCreate = (device, name) => {
        this.checkConnectionToServer()
        this.props.createDevice({deviceId: device, label: name}, (response) => {
            log.debug("response", response)
            this.props.fetchDevices(() => {
                setTimeout(() => {
                    this.props.history.push("/")
                }, 500)
            })
        }, (err) => {
            try {
                if(err.status === 403 ) {
                    // TODO show toast
                    ToasterService.error("Gerät ist nicht verbunden oder im selben Netzwerk!")
                }
                else if (err.status === 401) {
                    this.props.history.push("/login")
                }
            } catch(error) {
                log.error(error)
            }

        });
    }

    componentWillReceiveProps(nextProps) {
        if(Object.keys(nextProps.allDevices).length > 0) {
            this.props.history.push("/")
        }
    }

    componentDidMount() {
        if(Object.keys(this.props.allDevices).length > 0) {
            this.props.history.push("/")
        }
    }

    render() {
        this.checkConnectionToServer()
        return (
            <OnboardingView deleteUser={this.props.deleteUser} onCreate={this.handleCreate.bind(this)} onLogin={this.handleLogin} />
        );
    }
}

export default withTitle(withRouter(connect(mapStateToProps, mapDispatchToProps)(Onboarding)), title);
